


































import { Vue, Component } from "vue-property-decorator";
import { Form, Calendar, Picker, List, PullRefresh } from "vant";
import bus from "./bus";
import btripServcice from "@/service/btripServcice";
@Component({
  name: "projectList",
  components: {
    [Form.name]: Form,
    [Calendar.name]: Calendar,
    [Picker.name]: Picker,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
  },
})
export default class extends Vue {
  isDropDownlLoading = false;
  isPullUploading = false;
  finished = false;
  isLaunch = false;
  model = {
    PageNo: 0,
    PageSize: 15,
  };
  projectLists: any = [];
  actived() {
    // this.loadWorks()
  }
  created() {
    // this.loadWorks()
    console.log(bus);
  }

  Launch() {}
  formatDate(value: Date, format: string = "YYYY-MM-DD") {
    if (!value) {
      return value;
    }
    return (this as any).$moment(value).format(format);
  }
  onLoad() {
    console.log("触发了");
    this.model.PageNo++;
    btripServcice.getBtripProjectList(this.model as any).then((json: any) => {
      if (json.isSucc) {
        if (json.result.entities.length !== 0) {
          for (let i = 0; i < json.result.entities.length; i++) {
            this.projectLists.push(json.result.entities[i]);
          }

          this.isPullUploading = false;
        } else {
          this.finished = true;
        }
      }
    });
    console.log(this.projectLists);
  }
  onRefresh() {
    btripServcice.getBtripProjectList(this.model as any).then((json: any) => {
      if (json.isSucc) {
        if (json.result.entities.length !== 0) {
          for (let i = 0; i < json.result.entities.length; i++) {
            json.result.entities[i].CreateAt;
          }
          this.isDropDownlLoading = false;
          this.$toast.success("刷新成功");
        }
      }
    });
  }
  ChooseCard(item: any) {
    console.log(item);
    bus.$emit("projectEvent", item);
    this.back();
  }
  back() {
    history.back();
  }
}
